import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/img/home/solution/en_home_goldcircle.png'
import _imports_1 from '../../../public/img/investorkits/23-investor_pdficon.png'


const _withScopeId = n => (_pushScopeId("data-v-59fad244"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "committee-box" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"home-title\" data-v-59fad244><div class=\"title\" style=\"display:flex;align-items:center;color:#000;margin:7px 0;\" data-v-59fad244><img src=\"" + _imports_0 + "\" alt=\"\" data-v-59fad244><div style=\"display:flex;flex-direction:column;\" data-v-59fad244><p style=\"color:#000;font-size:1.5rem;margin-left:-15px;letter-spacing:2px;\" data-v-59fad244>ANNUAL GENERAL MEETING</p></div></div></div>", 1)
const _hoisted_3 = { class: "press-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#000","font-size":"1.2rem","font-weight":"600","margin-bottom":"20px"} }, "2024 Annual Meeting ", -1))
const _hoisted_5 = ["item"]
const _hoisted_6 = { style: {"display":"flex","justify-content":"flex-start","align-items":"center","gap":"20px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_8 = { style: {"color":"#000","font-size":"1rem","max-width":"90%","line-height":"1.7"} }

import Footer from "@/components/home/Footer.vue";
  import { ref, reactive } from "vue";
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Annual',
  setup(__props) {

  const datas = reactive([
    {
      name: "Annual Report",
    },
    {
      name: "Proxy Card",
    },
    {
      name: "Proxy Statement",
    }
  ]);
  
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            item: item
          }, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1)
            ]),
            _createElementVNode("hr", {
              style: _normalizeStyle([{"margin":"2rem 0","border-top":"1px solid rgba(12, 106, 204, 0.2)"}, {display: index === datas.length - 1 ? 'none' : ''}])
            }, null, 4)
          ], 8, _hoisted_5))
        }), 128))
      ])
    ]),
    _createVNode(Footer)
  ], 64))
}
}

})